import { required, email } from 'vee-validate/dist/rules';
import { extend } from 'vee-validate';

extend('required', {
  ...required,
  message: 'Este campo es obligatorio.',
});

extend('email', {
  ...email,
  message: 'No es un email.',
});
